import { render, staticRenderFns } from "./add-item-button.vue?vue&type=template&id=4bdf1817&"
import script from "./add-item-button.vue?vue&type=script&lang=ts&"
export * from "./add-item-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports